angular.module('zc.projects')

.directive 'zcCampaignSegmentList', ($injector, $state, $translate, CampaignSegment, Meta, Devise, lib) ->
  restrict: 'E'
  templateUrl: "/templates/projects.segments/campaign_segment_list.html"
  replace: true
  scope:
    currentProject: '='
  link: (scope, element, attrs) ->
    scope.Devise = Devise
    scope.campaign_segments = []

    if scope.Devise.isMaster()
      scope.masterFeaturesAllowed = true

    scope.updateCampaignSegments = () ->
      CampaignSegment.all(scope.currentProject.id).then (res) ->
        # Ignore all custom_olds and sort latest up
        scope.campaign_segments = _.chain res
          .filter (d) -> d.segment_type != 'custom_old'
          .filter (d) -> !d.deprecated
          .sortBy (d) -> -new Date(d.created_at)
          .value()

    scope.copySegment = (campaignSegment) ->
      # do not allow copying old segments!
      if campaignSegment.segment_type == 'custom_old'
        alertify.error($translate.instant('projectsSegments.directives.campaignSegmentList.furui_shikumi_no'))
        return
      newSegment = _.assignIn {}, campaignSegment, newSegment
      newSegment.id = undefined
      newSegment.name = lib.copyName(newSegment.name)

      CampaignSegment.create({projectId: scope.currentProject.id}, newSegment).then (res) ->
        scope.updateCampaignSegments()

    scope.removeSegment = (campaignSegment) ->
      CampaignSegment.delete(scope.currentProject.id, campaignSegment.id).then (res) ->
        scope.updateCampaignSegments()

    scope.invalidateSegment = (campaignSegment) ->
      CampaignSegment.update({projectId: scope.currentProject.id, id: campaignSegment.id}, deprecated: true).then (res) ->
        scope.updateCampaignSegments()

    scope.updateCampaignSegments()



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.segments/campaign_segment_list.directive.coffee